/** Pulse placeholder for loading rows and cards */
function Bar({ className = '' }) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-slate-200/80 ${className}`}
      aria-hidden
    />
  )
}

export function TableRowSkeleton({ cols = 6 }) {
  return (
    <tr>
      {Array.from({ length: cols }).map((_, i) => (
        <td key={i} className="px-2.5 py-[7px]">
          <Bar className="h-4 w-full max-w-[8rem]" />
        </td>
      ))}
    </tr>
  )
}

export function CardSkeleton() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <Bar className="mb-4 h-5 w-1/3" />
      <Bar className="mb-2 h-8 w-2/3" />
      <Bar className="h-3 w-full" />
    </div>
  )
}

export function DashboardStatSkeleton() {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <Bar className="mb-3 h-4 w-24" />
      <Bar className="h-9 w-16" />
    </div>
  )
}
